import {usePage} from "@inertiajs/react";

type SharedProps = {
    isAuthenticated: boolean;
};

export const useIsAuthenticated = () => {
    const {isAuthenticated} = usePage<SharedProps>().props;

    return isAuthenticated;
};
